export default __webpack_public_path__ + "static/media/night-rain.ef3be785.svg";